/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { useState } from "react";
import Box from "@mui/material/Box";
import SearchAccount from "../components/views/passwordRecovery/SearchAccount";
import VerifyPassword from "../components/views/passwordRecovery/VerifyCode";
import ChangePassword from "../components/views/passwordRecovery/ChangePassword";
import { UserInterface } from "medicalsystem-shared";

/**
 * Multi-step password recovery wizard.
 * 
 * Three-step process:
 * 1. SearchAccount: User enters email or username to locate their account
 * 2. VerifyCode: System sends verification code, user enters it for validation
 * 3. ChangePassword: User creates new password after successful verification
 * 
 * Features:
 * - Full-screen overlay preventing background interaction
 * - Step-by-step navigation with state management
 * - User data persistence across steps
 * - Secure verification code validation
 * - Password change without requiring old password
 * 
 * The component manages the recovery flow state and passes appropriate
 * callbacks and data to each step component.
 * 
 * @returns Password recovery stepper component
 */
const PasswordRecoveryStepper = () => {
  const [step, setStep] = useState(0);
  const [user, setUser] = useState<UserInterface | null>(null);

  const handleUserFound = (foundUser: UserInterface) => {
    setUser(foundUser);
    setStep(1);
  };

  const handleCodeVerified = () => {
    setStep(2);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "background.default",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
      }}
    >
      {step === 0 && <SearchAccount onNext={handleUserFound} />}
      {step === 1 && <VerifyPassword onNext={handleCodeVerified} user={user} />}
      {step === 2 && user && <ChangePassword user={user} />}
    </Box>
  );
};

export default PasswordRecoveryStepper;

